import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Calendar, ArrowLeft, Clock } from 'lucide-react';
import DOMPurify from 'dompurify';
import './BlogPost.css';
const BlogPost = () => {
  const API = process.env.REACT_APP_BACKEND_URL;
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPost();
  }, [slug]);

  const fetchPost = async () => {
    try {
      const response = await axios.get(`${API}/api/wordpress/posts/${slug}`);
      setPost(response.data);
    } catch (error) {
      console.error('Error fetching blog post:', error);
      setError('Blog post not found');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  if (loading) {
    return (
      <div className="blog-post-container">
        <div className="container">
          <div className="blog-loading">Loading article...</div>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="blog-post-container">
        <div className="container">
          <div className="blog-error">
            <h2>Article Not Found</h2>
            <p>{error}</p>
            <Link to="/blog" className="btn-primary">Back to Blog</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-post-container">
      <div className="container">
        <Link to="/blog" className="back-to-blog">
          <ArrowLeft size={20} />
          <span>Back to Blog</span>
        </Link>

        <article className="blog-post">
          <div className="blog-post-header">
            <div className="blog-post-meta">
              <span className="blog-post-date">
                <Calendar size={18} />
                {formatDate(post.published_date)}
              </span>
              <span className="blog-post-author">
                By {post.author}
              </span>
            </div>
            <h1 className="heading-1">{post.title}</h1>
          </div>

          {post.featured_image && (
            <div className="blog-post-image">
              <img src={post.featured_image} alt={post.title} />
            </div>
          )}

          <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content) }} />
        </article>
      </div>
    </div>
  );
};

export default BlogPost;
